import { render, staticRenderFns } from "./ActItemPreview.vue?vue&type=template&id=7f874766&scoped=true&"
import script from "./ActItemPreview.vue?vue&type=script&lang=ts&"
export * from "./ActItemPreview.vue?vue&type=script&lang=ts&"
import style0 from "./ActItemPreview.vue?vue&type=style&index=0&id=7f874766&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f874766",
  null
  
)

export default component.exports